import { render, staticRenderFns } from "./Purchase_edit.vue?vue&type=template&id=d2a1d8b8&scoped=true&"
import script from "./Purchase_edit.vue?vue&type=script&lang=js&"
export * from "./Purchase_edit.vue?vue&type=script&lang=js&"
import style0 from "./Purchase_edit.vue?vue&type=style&index=0&id=d2a1d8b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a1d8b8",
  null
  
)

export default component.exports